import PresentationMetadata from './PresentationMetadataService';
import PresentationModel from './PresentationModelService';
import HeaderAndFooterPresentationMetadata from './PresentationMetadataHeaderAndFooterService';
import 'l10nModule';

export default angular.module('edge.platform.uimetadata', ['edge.platform.l10n'])
    .factory('PresentationMetadata', PresentationMetadata)
    .factory('PresentationModelService', PresentationModel)
    .factory('PresentationMetadataHeaderAndFooter', HeaderAndFooterPresentationMetadata);
